import React, { useState, useEffect } from 'react';
import { siteData } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';

const HeroSection = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const [wordIndex1, setWordIndex1] = useState(0);
  const [wordIndex2, setWordIndex2] = useState(0);
  const [isAnimating1, setIsAnimating1] = useState(false);
  const [isAnimating2, setIsAnimating2] = useState(false);

  const words1 = t.hero.rotating1[lang] || t.hero.rotating1.nl;
  const words2 = t.hero.rotating2[lang] || t.hero.rotating2.nl;

  useEffect(() => {
    const interval1 = setInterval(() => {
      setIsAnimating1(true);
      setTimeout(() => { setWordIndex1((prev) => (prev + 1) % words1.length); setIsAnimating1(false); }, 400);
    }, 3000);
    const interval2 = setInterval(() => {
      setIsAnimating2(true);
      setTimeout(() => { setWordIndex2((prev) => (prev + 1) % words2.length); setIsAnimating2(false); }, 400);
    }, 3500);
    return () => { clearInterval(interval1); clearInterval(interval2); };
  }, [words1.length, words2.length]);

  return (
    <section className="relative min-h-screen flex flex-col justify-between overflow-hidden" style={{ background: '#0a0a0a' }}>
      <div className="absolute inset-0 opacity-40 pointer-events-none" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.5'/%3E%3C/svg%3E")`,backgroundSize:'256px'}} />
      <div className="absolute inset-0 opacity-[0.07]" style={{backgroundImage:`url(${siteData.hero.backgroundImage})`,backgroundSize:'cover',backgroundPosition:'center'}} />

      <div className="relative z-10 pt-28 md:pt-32 px-8 md:px-16 lg:px-24">
        <div className="flex items-start justify-between">
          <div className="space-y-0">
            {siteData.company.subtitles.map((sub, i) => (
              <p key={i} className="text-xs md:text-sm text-gray-500 tracking-[0.15em]">{sub}</p>
            ))}
          </div>
          <div className="hidden lg:block absolute left-1/2 -translate-x-1/2 top-20">
            <svg viewBox="0 0 140 80" className="w-32 md:w-40" fill="none">
              <circle cx="70" cy="36" r="33" stroke="white" strokeWidth="2" fill="none" />
              <path d="M95 8 Q106 0, 100 14" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
              <text x="38" y="42" fill="white" fontSize="17" fontWeight="700" fontFamily="Space Grotesk, sans-serif">cobras</text>
            </svg>
          </div>
        </div>
      </div>

      <div className="relative z-10 flex-1 flex items-center px-8 md:px-16 lg:px-24">
        <h1 className="text-[2.5rem] md:text-[4rem] lg:text-[5.5rem] xl:text-[6.5rem] font-black leading-[1.05] tracking-[-0.02em] max-w-[1400px]">
          <span className="text-white">{get(t.hero.line1)} </span>
          <span className="inline-block overflow-hidden align-bottom" style={{minWidth:'4ch'}}>
            <span className={`inline-block font-black italic transition-all duration-500 ${isAnimating1?'translate-y-full opacity-0':'translate-y-0 opacity-100'}`} style={{color:'#A855F7'}}>{words1[wordIndex1]}</span>
          </span>
          <br />
          <span className="text-white">{get(t.hero.line2)} </span>
          <span className="inline-block overflow-hidden align-bottom" style={{minWidth:'4ch'}}>
            <span className={`inline-block font-black italic transition-all duration-500 ${isAnimating2?'-translate-y-full opacity-0':'translate-y-0 opacity-100'}`} style={{color:'#A855F7'}}>{words2[wordIndex2]}</span>
          </span>
          <span className="text-white">.</span>
          <br />
          <span className="text-white">{get(t.hero.tagline)}</span>
        </h1>
      </div>

      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10">
        <div className="w-[2px] h-10 bg-gradient-to-b from-[#A855F7] to-transparent animate-pulse" />
      </div>
    </section>
  );
};

export default HeroSection;
